import { Link, useLocation } from 'react-router-dom';
import { useCategories } from '../../hooks/useDocs';
import styles from './Sidebar.module.css';

export default function Sidebar() {
  const location = useLocation();
  const { categories, loading } = useCategories();

  // 直觉排序：AI → 前端 → 后端 → 通用文章 → 语言 → 工具 → 调试，未列出的按标题字母序兜底
  const orderMap: Record<string, number> = {
    'ai-docs': 0,
    web: 1,
    system: 2,
    article: 3,
    language: 4,
    tools: 5,
    debug: 6,
    life: 7,
  };
  const sortedCategories = [...categories].sort((a, b) => {
    const ai = orderMap[a.slug] ?? 99;
    const bi = orderMap[b.slug] ?? 99;
    if (ai !== bi) return ai - bi;
    return a.title.localeCompare(b.title);
  });

  // 判断「全部」是否处于激活状态（位于全量文档列表页 /archive/all）
  const isAllActive = location.pathname === '/archive/all' || location.pathname === '/archive/all/';

  return (
    <aside className={styles.sidebar}>
      <div className={styles.header}>
        <span className={styles.headerIcon}>◈</span>
        <span className={styles.headerText}>ARCHIVE</span>
      </div>

      <nav className={styles.nav}>
        <div className={styles.section}>
          <div className={styles.sectionTitle}>CATEGORIES</div>
          {loading ? (
            <div className={styles.item}>Loading...</div>
          ) : (
            <>
              <Link
                to="/archive/all"
                className={`${styles.item} ${isAllActive ? styles.active : ''}`}
              >
                <span className={styles.icon}>◈</span>
                <span className={styles.label}>全部</span>
              </Link>
              {sortedCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/archive/${cat.slug}`}
                  className={`${styles.item} ${location.pathname.includes(cat.slug) ? styles.active : ''}`}
                >
                  <span className={styles.icon}>{cat.icon}</span>
                  <span className={styles.label}>{cat.title}</span>
                </Link>
              ))}
            </>
          )}
        </div>
      </nav>

      <div className={styles.footer}>
        <span className={styles.version}>v2.77</span>
      </div>
    </aside>
  );
}
